import { makeRequestCreator } from './common.js'
import store from '@/store'

const productAPI = {
  /**
   * 카테고리 별 제품 목록을 요청한다.
   * @param {string} categoryId - 목록을 요청할 카테고리 id
   * @param {number} page - 페이지 번호
   * @param {number} pageSize - 한 페이지 당 표시할 목록 갯수
   * @param {Function} successCallback - 호출 성공시 호출할 콜백
   * @param {Function} errorCallback - 호출 실패시 호출할 콜백
   */
  getProductListByCategory: (categoryId, page, pageSize, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getProductListByCategory',
      {
        method: 'post',
        url: `/v2/product/list/${store.getters['main/shopSeq']}/${categoryId}`,
        data: {
          page,
          pageSize
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 제품 ID별 제품 목록을 요청한다.
   * @param {Array} productIds - 제품 id 배열
   * @param {Function} successCallback - 호출 성공시 호출할 콜백
   * @param {Function} errorCallback - 호출 실패시 호출할 콜백
   */
  getProductListByIds: (productIds, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getProductListByIds',
      {
        method: 'post',
        url: `/v2/product/list/byids/${store.getters['main/shopSeq']}`,
        data: {
          productIds
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * tag별 제품 목록을 요청한다.
   * @param {Number} tagName - 태그이름
   * @param {number} page - 페이지 번호
   * @param {number} pageSize - 한 페이지 당 표시할 목록 갯수
   * @param {Function} successCallback - 호출 성공시 호출할 콜백
   * @param {Function} errorCallback - 호출 실패시 호출할 콜백
   */
  getProductListByTag: (tagName, page, pageSize, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getProductListByIds',
      {
        method: 'post',
        url: `/v2/product/list/bytag/${store.getters['main/shopSeq']}`,
        data: {
          tagName,
          page,
          pageSize
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 제품의 상세 정보를 요청한다.
   * @param {Number} productId - 제품 id
   * @param {Function} successCallback - 호출 성공시 호출할 콜백
   * @param {Function} errorCallback - 호출 실패시 호출할 콜백
   */
  getProductInfo: (productId, og, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    let ogQuery = og ? `?og=${og}` : ''
    makeRequestCreator(
      'getProductList',
      {
        method: 'get',
        url: `/v2/product/${store.getters['main/shopSeq']}/${productId}${ogQuery}`,
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 펀딩 상품 정보를 요청한다.
   * @param {Number} productId - 제품 id
   * @param {Function} successCallback - 호출 성공시 호출할 콜백
   * @param {Function} errorCallback - 호출 실패시 호출할 콜백
   */
  getFundingInfo: (productId, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'getFundingInfo',
      {
        method: 'get',
        url: `/v2/product/funding/${store.getters['main/shopSeq']}/${productId}`,
      },
      successCallback,
      errorCallback
    )
  }
}

export default productAPI
